<template>
    <div>
        <div class="row">
            <div class="cole-12 col-md-6">
                <div class="form-row">
                    <div class="col-12 col-md-8 form-group">
                        <input class="form-control" v-model="searchedId" v-on:keyup.enter="searchById()"
                               :placeholder="is_admin ? this.$lang('ID zgłoszenia / Jira ID') : this.$lang('ID zgłoszenia')">
                    </div>
                    <div class="col-12 col-md-4">
                        <button class="btn btn-primary btn-block mb-1"
                                type="button" @click="searchById()">{{ $lang('Znajdź po ID') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="form-group col-12 col-md-6" v-if="is_admin">
                <a :href="add_route">
                    <button class="btn btn-primary pull-right" type="button">{{ $lang('Dodaj pracę zdalną') }}</button>
                </a>
            </div>
        </div>
        <form id="searchForm" class="mb-5">
            <div class="form-row col-12 px-0">
                <div class="col-md-6 form-group ">
                    <strong><label for="year">{{ $lang('Rok') }}</label></strong>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-calendar" aria-hidden="true"></i></div>
                        </div>
                        <input class="form-control" type="number" min="0" name="year" id="year" placeholder="Podaj rok"
                               v-model="year">
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <strong><label for="month">{{ $lang('Miesiąc') }}</label></strong>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-calendar" aria-hidden="true"></i></div>
                        </div>
                        <select class="form-control" name="month" id="month" v-model="month">
                            <option value="">{{ $lang('wszystkie') }}</option>
                            <option value="01">{{ $lang('Styczeń') }}</option>
                            <option value="02">{{ $lang('Luty') }}</option>
                            <option value="03">{{ $lang('Marzec') }}</option>
                            <option value="04">{{ $lang('Kwiecień') }}</option>
                            <option value="05">{{ $lang('Maj') }}</option>
                            <option value="06">{{ $lang('Czerwiec') }}</option>
                            <option value="07">{{ $lang('Lipiec') }}</option>
                            <option value="08">{{ $lang('Sierpień') }}</option>
                            <option value="09">{{ $lang('Wrzesień') }}</option>
                            <option value="10">{{ $lang('Październik') }}</option>
                            <option value="11">{{ $lang('Listopad') }}</option>
                            <option value="12">{{ $lang('Grudzień') }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div v-if="is_admin" class="form-row col-12 px-0">
                <div class="form-group col-12">
                    <strong><label for="library">{{ $lang('Biblioteka') }}</label></strong>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="bg-icon"><i class="fa fa-university" aria-hidden="true"></i></div>
                        </div>
                        <select name="library" id="library" class="form-control" v-model="libraryID">
                            <option value="">{{ $lang('wszystkie') }}</option>
                            <option v-for="library in libraries" :value="library.id">{{ library.name }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-row col-12 pr-0">
                    <div class="col-lg-4 col-md-6 form-group">
                        <strong><label for="status">{{ $lang('Status') }}</label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-flag" aria-hidden="true"></i></div>
                            </div>
                            <select class="form-control" name="status" id="status" v-model="statusID">
                                <option value="">{{ $lang('wszystkie') }}</option>
                                <option v-for="status in statuses" :value=status.id>{{ status.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 form-group pr-0">
                        <strong><label for="type">{{ $lang('Rodzaj usług') }}</label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-briefcase" aria-hidden="true"></i></div>
                            </div>
                            <select class="form-control" name="payment" id="payment" v-model="paymentID">
                                <option value="">{{ $lang('wszystkie') }}</option>
                                <option v-for="payment in payments" :value=payment.id>{{ payment.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 form-group pr-0">
                        <strong><label for="type">{{ $lang('Typ prac zdalnych') }}</label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-wrench" aria-hidden="true"></i></div>
                            </div>
                            <select class="form-control" name="type" id="type" v-model="typeID">
                                <option value="">{{ $lang('wszystkie') }}</option>
                                <option v-for="type in types" :value=type.id>{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <button id="button" class="pull-right btn btn-primary"
                    type="button" @click="search()">{{ $lang('Szukaj') }}
            </button>
            <reload-button class="pull-right mb-5 mx-3"></reload-button>
        </form>

        <div id="table">
            <div v-if="pagination.total>0">
                <pagination-component
                    :pagination="pagination"
                    :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
                ></pagination-component>
                <div class="form-row">
                    <div v-for="remote_job in remotes" class="card col-12 p-0 mt-4">
                        <div class="card-header pt-1 pb-1">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-8">
                                    <div class="row">
                                        <div class="p-0 pl-1 mr-2 col-12 col-sm-12 col-md-12 col-lg-9">
                                            <strong>{{ remote_job.library.name + ':&nbsp;' }}</strong>
                                            {{ remote_job.client.name + " " + remote_job.client.surname }}
                                        </div>
                                        <div v-if="remote_job.prolib_version && is_admin">
                                            <p class="m-0 p-0 pl-1">
                                                <strong>{{ $lang('Wersja:&nbsp;') }}</strong>
                                                {{ remote_job.prolib_version }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-12 col-md-6 col-lg-4 pull-right text-right pl-0">
                                    <template v-for="type in types">
                                        <span
                                            v-if="remote_job.job_type === type.id">{{
                                                remote_job.job_id + ' - ' + type.name
                                            }}</span>
                                    </template>
                                    <i v-on:click="showDetails(remote_job.id)" :id="'details-btn-'+remote_job.id"
                                       class="fa-angle-double-down fa tile icon fa-lg ml-2" :ref="'show-details-'+remote_job.id"
                                       aria-hidden="true"></i>

                                    <i v-on:click="print(remote_job)" class="ml-2 fa fa-print tile icon fa-lg print"
                                       aria-hidden="true" :title="$lang('Drukuj')"></i>

                                    <i v-if="is_admin" v-on:click="copyRemoteJob(remote_job)"
                                       class="ml-2 fa fa-copy tile icon fa-lg print"
                                       aria-hidden="true" :title="$lang('Kopiuj')"></i>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-1 m-1">
                            <div :id="'details-'+remote_job.id" :hidden="true">
                                <dl class=" row col-12 mb-0">
                                    <div class="col-12 col-md-auto row m-0 p-0">
                                        <dt class="col-6 col-md-12 m-0 p-0">{{ $lang("Konsultant&nbsp;") }}</dt>
                                        <dd class="col-6 col-md-12 m-0 p-0" v-if="remote_job.consultant">{{
                                                remote_job.consultant.name + " " +
                                                remote_job.consultant.surname
                                            }}
                                        </dd>
                                        <dd class="col-6 col-md-12 m-0 p-0" v-else>
                                            <template v-if="remote_job.job_type === 1">
                                                {{ $lang('Brak zamówionych konsultacji') }}
                                            </template>
                                            <template v-else>
                                                {{ $lang('Brak konsultanta') }}
                                            </template>
                                        </dd>
                                    </div>
                                    <div class="col-12 col-md-auto row m-0 p-0">
                                        <dt class="col-6 col-md-12 m-0 p-0">{{ $lang("Wykonawca&nbsp;") }}</dt>
                                        <dd class="col-6 col-md-12 m-0 p-0">{{
                                                remote_job.performer.name + " " +
                                                remote_job.performer.surname
                                            }}
                                        </dd>
                                    </div>
                                    <div class="col-12 col-md-auto row m-0 p-0" v-if="is_admin">
                                        <dt class="col-6 col-md-12 m-0 p-0">
                                            {{ $lang('Status płatności') }}
                                        </dt>
                                        <dd class="col-6 col-md-12 m-0 p-0">
                                            <template v-for="payment in payments">
                                                <span v-if="remote_job.payment===payment.id">{{ payment.name }}</span>
                                            </template>
                                        </dd>
                                    </div>
                                    <div class="col-12 col-md-auto row m-0 p-0">
                                        <dt class="col-6 col-md-12 m-0 p-0" v-if="remote_job.task_id">
                                            {{ $lang('Zgłoszenie nr') }}
                                        </dt>
                                        <dd class="col-6 col-md-12 m-0 p-0" v-if="remote_job.task_id">
                                            <a :href="'/task/' + remote_job.task_id"
                                               target="_blank">{{ remote_job.task_id }}</a>
                                        </dd>
                                    </div>
                                    <div class="col-12 col-md-auto row m-0 p-0">
                                        <dt class="col-6 col-md-12 m-0 p-0" v-if="remote_job.jira_id">
                                            {{ $lang('Zlecenie') }}
                                        </dt>
                                        <dd class="col-6 col-md-12 m-0 p-0" v-if="remote_job.jira_id">
                                            <a v-if="is_admin && jiraOrPtd(remote_job.jira_id)"
                                               :href="externLink(remote_job.jira_id)" target="_blank">
                                                {{ remote_job.jira_id }} </a>
                                            <span v-else>{{ remote_job.jira_id }}</span>
                                        </dd>
                                    </div>
                                    <div class="col-12 col-md-auto ml-auto row m-0 p-0"
                                         v-if="is_admin && remote_job.status === waitStatusID()">
                                        <button class="col-12 col-md-auto pull-right btn btn-primary"
                                                @click="changeStatus(remote_job.id, 'NO_RESPONSE', null)">
                                            {{ $lang('Zakończ') }}
                                        </button>
                                    </div>
                                    <template
                                         v-if="!is_admin && remote_job.status === waitStatusID()">
                                        <div class="col-12 col-md-auto ml-auto row m-0 p-0"
                                             v-if="new Date(remote_job.effective_date).setUTCHours(0,0,0,0)<=today">
                                            <button class="col-12 col-md-auto pull-right btn btn-primary mr-1 mb-1"
                                                    @click="rejectRemoteJob(remote_job.id)"
                                                    data-toggle="modal" data-target="#rejection-reason-modal">
                                                {{ $lang('Nie Potwierdzam') }}
                                            </button>
                                            <button class="col-12 col-md-auto btn btn-primary mb-1"
                                                    @click="changeStatus(remote_job.id, 'CONFIRMED', null)">
                                                {{ $lang('Potwierdzam') }}
                                            </button>
                                        </div>
                                        <div class="col-12 col-md-auto row m-0 p-0" v-else>
                                            <dt class="col-6 col-md-12 m-0 p-0">
                                                <span> {{ $lang('Możliwość weryfikacji i potwierdzenia pracy zdalnej od:') }} </span>
                                            </dt>
                                            <dd class="col-6 col-md-12 m-0 p-0 align-self-center">
                                                <span> {{ remote_job.effective_date_showable }} </span>
                                            </dd>
                                        </div>
                                    </template>
                                </dl>
                                <dl class="row col-12 mb-0">
                                    <div class="col-12 col-md-auto m-0 p-0">
                                        <dt class="col-6 col-md-12 m-0 p-0 mt-2" v-if="remote_job.rejection_reason">
                                            {{ $lang('Powód odrzucenia') }}
                                        </dt>
                                        <dd class="col-6 col-md-12 m-0 p-0" v-if="remote_job.rejection_reason"
                                            v-html="nl2br(remote_job.rejection_reason)">
                                        </dd>
                                    </div>
                                </dl>
                            </div>

                            <div class="col-12 my-2 m-0 p-0" v-if="remote_job.description">
                                <p class="p-0 m-0" style="text-align: justify">
                                    <strong>{{ $lang("Opis: ") }}</strong>
                                    {{ remote_job.description }}
                                </p>
                            </div>

                            <div class="col-12 my-2 m-0 p-0" v-if="is_admin && (remote_job.effective_date!==undefined && remote_job.effective_date!==null) && remote_job.status === waitStatusID()">
                                <p class="p-0 m-0" style="text-align: justify">
                                    <strong>{{ $lang("Możliwość weryfikacji i potwierdzenia pracy zdalnej od: ") }}</strong>
                                    {{ remote_job.effective_date_showable }}
                                </p>
                            </div>

                            <!--                        <div :id="'buttons-'+remote_job.id" :hidden="true">-->
                            <!--                            <div v-if="is_admin && remote_job.status === waitStatusID()" class="col-12">-->
                            <!--                                <button class="col-12 col-md-auto pull-right btn btn-primary"-->
                            <!--                                        @click="changeStatus(remote_job.id, 'NO_RESPONSE')">-->
                            <!--                                    {{$lang('Zakończ')}}-->
                            <!--                                </button>-->
                            <!--                            </div>-->
                            <!--                        </div>-->
                        </div>
                        <div class="card-footer pt-1 pb-1 pr-0">
                            <div class="row mx-0 px-0">

                                <div class="col-8 ml-0 pl-0">
                                    <div class="row">
                                        <div class="p-0 mr-2 col-12 col-sm-10 col-md-8 col-lg-6">
                                            <template v-for="status in statuses">
                                                <span v-if="remote_job.status === status.id"
                                                      :class="'badge badge-remote-'+status.id">
                                                    {{ status.name }}
                                                </span>
                                            </template>
                                        </div>
                                        <div v-if="remote_job.confirm_date">
                                            <p class="m-0 p-0">
                                                <strong>{{ $lang('Data potwierdzenia:&nbsp;') }}</strong>
                                                {{ remote_job.confirm_date_showable }}
                                            </p>
                                        </div>
                                        <div v-if="remote_job.reject_date">
                                            <p class="m-0 p-0">
                                                <strong>{{ $lang('Data odrzucenia:&nbsp;') }}</strong>
                                                {{ remote_job.reject_date_showable }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-4 pull-right text-right pl-0">{{ remote_job.start_date_showable }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <pagination-component class="mt-3"
                                      :pagination="pagination"
                                      :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
                ></pagination-component>
            </div>
            <div v-else>
                <strong>{{ $lang("Brak prac zdalnych, zmień kryteria wyszukwiania.") }}</strong>
            </div>
        </div>
        <generating-modal></generating-modal>
        <remote-rejection-modal></remote-rejection-modal>
    </div>
</template>

<script>
import {EventBus} from "../../mixins/event-bus";
import GeneratingModal from "../generating-modal";
import ShowNotification from "../../mixins/show-notification";
import axios from "axios";
import moment from "moment";
import LineBreakConverter from "../../mixins/line-break-converter";

export default {
    mixins: [ShowNotification, LineBreakConverter],
    name: 'remote-index',
    components: {GeneratingModal},
    props: {
        add_route: String,
        search_route: String,
        search_by_id_route: String,
        print_route: String,
        change_status_remote_route: String,
        copy_remote_route: String,
        put_data_in_session_route: String,
        is_admin: Boolean,
        libraries: Array,
        pdf_name: String,
        jira_link: String,
        ptd_link: String,
        payments: Array,
        types: Array,
        statuses: Array,
        searched_task_id: Number,
        expand_unconfirmed: Boolean,
    },
    data() {
        return {
            pagination: [],
            remotes: [],
            year: '',
            month: '',
            libraryID: '',
            statusID: '',
            paymentID: '',
            typeID: '',
            searchedId: this.searched_task_id !== 0 ? this.searched_task_id : '',
            isSearchedById: false,
            sessionValue: 'copied_remote',
            today: null,
        }
    },
    watch: {
        year() {
            this.isYearValid();
        },
        remotes() {
            this.$nextTick(() => {
                this.remotes.forEach(remote => {
                    if (remote.status === this.waitStatusID() && this.expand_unconfirmed && !this.is_admin) {
                        this.showDetails(remote.id);
                    }
                });
            })
        }
    },
    methods: {
        isYearValid() {
            if (this.year == null || this.year < 2000 || this.year > 3000) {
                this.month = 0;
                document.getElementById('month').disabled = true;
                document.getElementById('button').disabled = true;
            } else {
                this.month = this.month = ('0' + ((new Date).getMonth() + 1)).slice(-2);
                document.getElementById('month').disabled = false;
                document.getElementById('button').disabled = false;
            }
        },
        setParam(arrParam) {
            if (arrParam)
                return arrParam;
            else
                return '';
        },
        print(remote) {
            $("#generatingModal").modal('show');
            let params = {
                remote_job: remote,
                payments: this.payments,
                types: this.types,
            };
            let self = this;
            axios({
                method: 'post',
                url: self.print_route,
                data: params,
                responseType: 'blob'
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    if (typeof window.navigator.msSaveBlob === 'function') {
                        window.navigator.msSaveBlob(
                            response.data,
                            remote.job_id + '.pdf'
                        );
                    } else {
                        link.setAttribute('download', remote.job_id + '.pdf');
                        document.body.appendChild(link);
                        link.click();

                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function () {
                    setTimeout(function () {
                        $("#generatingModal").modal('hide');
                    }, 250, this);
                });
        },
        copyRemoteJob(remote) {
            let self = this;
            axios.post(self.put_data_in_session_route, {'dataType': self.sessionValue, 'data': remote})
                .then(function (response) {
                    window.location.href = self.copy_remote_route;
                }).catch(function (error) {
                    console.log(error);
            });
        },
        search() {
            this.isSearchedById = false;
            this.generate(1);
        },
        searchById() {
            this.isSearchedById = true;
            this.generate(1);
        },
        generate(page) {
            let self = this;
            let axiosUrl = self.search_route;
            let parameters = {
                page: page,
                year: self.year,
                month: self.month,
                library: self.libraryID,
                status: self.statusID,
                payment: self.paymentID,
                type: self.typeID,
            }
            if (this.isSearchedById) {
                axiosUrl = self.search_by_id_route;
                parameters = {
                    page: page,
                    searchedId: self.searchedId,
                }
            }
            axios({
                method: 'get',
                url: axiosUrl,
                params: parameters
            })
                .then(function (response) {
                    self.pagination = response.data;
                    self.remotes = self.pagination.data;
                    document.getElementById("table").scrollIntoView();
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        setEventBusListenerPages() {
            EventBus.$on('changePage', ({value}) => {
                this.generate(value);
            });
        },
        waitStatusID() {
            for (let status of this.statuses) {
                if (status.key === 'WAIT') {
                    return status.id;
                }
            }
            return null;
        },
        changeStatus(id, statusName, reason) {
            let self = this;
            axios.get(this.change_status_remote_route, {
                params: {
                    remote_id: id,
                    status_name: statusName,
                    reason: reason
                }
            })
                .then((response) => {
                    this.generate(1);
                    if (response.data.result === 'ok') {
                        this.showNotification('success', 'Zmieniono status potwierdzenia!');
                    } else if (response.data.result === 'error') {
                        this.showNotification('warning', 'Status został już zmieniony!');
                    } else {
                        this.showNotification('error', 'Wystąpił błąd!');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        showDetails(id) {
            let div = document.getElementById('details-' + id);
            let btn = document.getElementById('details-btn-' + id);
            if (div.hidden === false) {
                div.hidden = true;
                btn.classList.remove('fa-angle-double-up')
                btn.classList.add('fa-angle-double-down')
            } else {
                div.hidden = false;
                btn.classList.remove('fa-angle-double-down')
                btn.classList.add('fa-angle-double-up')
            }
        },
        jiraOrPtd(id) {
            return id.match(/([a-zA-Z0-9]{4}-[a-zA-Z0-9]{6}$)|([a-zA-Z0-9]+-[0-9]+$)/);
        },
        externLink(id) {
            if (id.match(/[a-zA-Z0-9]+-[0-9]+$/)) {
                return this.jira_link + id;
            } else if (id.match(/[a-zA-Z0-9]{4}-[a-zA-Z0-9]{6}$/)) {
                return this.ptd_link + id;
            }
        },
        rejectRemoteJob(id) {
            EventBus.$emit('openRejectRemoteJobModal', {
                remoteId: id,
            });
        },
    },
    mounted() {
        let date = new Date();
        this.year = date.getFullYear();
        this.isYearValid();
        if (this.searchedId !== '') {
            this.searchById();
        } else {
            this.generate(1);
        }
        this.today = new Date().setUTCHours(0,0,0,0);
        EventBus.$on('rejectRemoteJob', (value) => {
            this.changeStatus(value.remoteId, 'NEGATIVE_RESPONSE', value.reason);
        });
    },
    created() {
        this.setEventBusListenerPages();
    }
}
</script>
